import { render, staticRenderFns } from "./wy-panel-pie-chart.vue?vue&type=template&id=c65f762e&"
import script from "./wy-panel-pie-chart.vue?vue&type=script&lang=js&"
export * from "./wy-panel-pie-chart.vue?vue&type=script&lang=js&"
import style0 from "./wy-panel-pie-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports